(ns ycweb.app.website.cart.pages.details-giftmessage
  (:require
   [rum.core :as rum]

   [ycweb.app.website.cart.parts.common :as cart.common]
   [ycweb.components.common :as cmn]
   [ycweb.components.forms :as forms]
   [ycweb.components.buttons :as buttons]))

(rum/defc gift-message-form < rum/reactive cmn/cursors
  {:init
   (fn [state props]
     (let [[app-atom process-atom cart-summary-atom] (:rum/args state)]
       (swap! cart-summary-atom assoc :delivery
         (get-in @cart-summary-atom [:cart :delivery])))
     state)}
  [app-atom process-atom cart-summary-atom]
  "Gift message form - matches step-05.html"
  (let [gift-message-atom (rum/cursor-in cart-summary-atom [:delivery :giftmessage])
        gift-message (rum/react gift-message-atom)
        occasion-atom (rum/cursor-in cart-summary-atom [:delivery :giftoccasion])
        occasion (rum/react occasion-atom)
        char-limit 150
        char-count (count (or gift-message ""))
        char-remaining (- char-limit char-count)]

    (cart.common/checkout-layout process-atom true
      (list

        [:h2 {:key "gift-heading" :class "yc-heading yc-heading--default"}
         "Would you like to include a gift message?"]
        [:p {:key "gift-description" :class "yc-paragraph"}
         "Your order will arrive neatly packed with your message handwritten on a card. We don't include invoices with orders, so your gifting secret is safe with us."]

        [:div {:key "gift-form" :class "form u-max-width-480 u-margin-bottom-40"}
         (forms/textarea "Gift message:"
           gift-message-atom
           {:hint (str char-remaining " characters remaining")
            :limit char-limit
            :rows 4
            :name "giftmessage"
            :id "giftmessage"
            :placeholder "e.g. Dear John, Happy Birthday! Love Jane."})

          ;; Need to implement this through the db, ecommerce_order and backend flows.
         #_(forms/select "What's the occasion?"
             occasion-atom
             [{:text "Select" :value ""}
              {:text "Birthday gift" :value "birthday"}
              {:text "Anniversary gift" :value "anniversary"}
              {:text "Engagement gift" :value "engagement"}
              {:text "Holiday gift" :value "holiday"}
              {:text "Corporate gift" :value "corporate"}]
             {})]

        [:div {:key "skip-button"}
         (buttons/button-web "Skip this step"
           {:on-click #(cart.common/skip-step app-atom process-atom cart-summary-atom nil %)
            :disabled (pos? char-count)
            :style :secondary
            :icon-placement :right
            :class "button--has-icon-right"
            :icon :arrow-right})])

      (cart.common/checkout-cta-sidebar app-atom process-atom cart-summary-atom
        {:disabled? (zero? char-count)
         :skip-disabled? (pos? char-count)
         :continue-fn
         #(swap! cart-summary-atom update-in [:cart :delivery] merge
            {:giftmessage gift-message
             :giftoccasion occasion})}))))

(defmethod cart.common/checkout-step :details/giftmessage
  [app-atom process-atom cart-summary-atom]
  (gift-message-form app-atom process-atom cart-summary-atom))